/**
 * @flow
 * @relayHash a9e9c1641e7c7d472768a5377fac7d7e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserAvatar_organisation$ref = any;
export type dealsFiltersOrganisationsQueryVariables = {|
  search?: ?string
|};
export type dealsFiltersOrganisationsQueryResponse = {|
  +organisations: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +emailAddress: ?string,
        +$fragmentRefs: UserAvatar_organisation$ref,
      |}
    |}>
  |}
|};
export type dealsFiltersOrganisationsQuery = {|
  variables: dealsFiltersOrganisationsQueryVariables,
  response: dealsFiltersOrganisationsQueryResponse,
|};
*/


/*
query dealsFiltersOrganisationsQuery(
  $search: String
) {
  organisations(search: $search, first: 30) {
    edges {
      node {
        ...UserAvatar_organisation
        id
        name
        emailAddress
      }
    }
  }
}

fragment UserAvatar_organisation on Organisation {
  id
  name
  primaryImage {
    url
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailAddress",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "dealsFiltersOrganisationsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organisations",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "OrganisationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OrganisationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Organisation",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "UserAvatar_organisation",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "dealsFiltersOrganisationsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organisations",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "OrganisationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OrganisationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Organisation",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "primaryImage",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Image",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "dealsFiltersOrganisationsQuery",
    "id": null,
    "text": "query dealsFiltersOrganisationsQuery(\n  $search: String\n) {\n  organisations(search: $search, first: 30) {\n    edges {\n      node {\n        ...UserAvatar_organisation\n        id\n        name\n        emailAddress\n      }\n    }\n  }\n}\n\nfragment UserAvatar_organisation on Organisation {\n  id\n  name\n  primaryImage {\n    url\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1dc0cb4c0771b415818bb1d725c88429';
module.exports = node;
